import React from 'react';
import PropTypes from 'prop-types';
import { I18n } from 'react-redux-i18n-lite';
import { AnnotationTypeIcon, ANNOTATION_TYPE_COLORS, HighlightMark, PageNotesRow } from '@netexknowledge/smart-components';

const renderTextNote = entry => (
  <>
    {entry.text}
    {entry.description && (
      <span className="page-notes-entry-quote">
        {entry.description}
        {entry.truncated && <span className="page-notes-entry-ellipsis">…</span>}
      </span>
    )}
  </>
);

/**
 * One annotation inside its page card. Without `onOpen` the row has no link (content not available).
 */
export default function PageNotesEntry({ entry, onOpen }) {
  const colors = ANNOTATION_TYPE_COLORS[entry.type];
  const icon = <AnnotationTypeIcon type={entry.type} color={colors.icon} />;

  if (entry.type === 'highlight') {
    return (
      <PageNotesRow icon={icon} onClick={onOpen}>
        <HighlightMark truncated={entry.truncated}>{entry.description}</HighlightMark>
      </PageNotesRow>
    );
  }

  return (
    <PageNotesRow icon={icon} label={I18n.t(`annotations.type.${entry.type}`)} labelColor={colors.text} onClick={onOpen}>
      {entry.type === 'note' ? <span className="page-notes-entry-value">{entry.value}</span> : renderTextNote(entry)}
    </PageNotesRow>
  );
}

PageNotesEntry.propTypes = {
  entry: PropTypes.shape({
    type: PropTypes.oneOf(['note', 'highlight', 'textNote']).isRequired
  }).isRequired,
  onOpen: PropTypes.func
};
